import apiService from "./apiServices";

  export const getQuotelisting = async (page, size,DateFrom,DateTo,token) => {
    try {
        const response = await apiService(`/quoteslist/all?page=${page}&size=${size}&fromDate=${DateFrom}&toDate=${DateTo}`, 'GET', null, null, token);
        return response;
      } catch (error) {
        throw (error?.message || 'service is failed. Please try again.');
      }
  }

  export const searchQuote = async(formData, token,page, size,sort,direction) => {
    try {
        const response = await apiService(`/search-quotes/search?page=${page}&size=${size}&sort=${sort}&direction=${direction}`, 'POST', formData, null, token);
        return response;
      } catch (error) {
        throw (error?.message || 'search quote service is failed. Please try again.');
      }
  }

